import { c as _c } from "react/compiler-runtime";
import type { FormikProps } from 'formik';
import { SurveyTypeIcon } from '@/components/SurveyTypeIcon';
import type { Entry, SurveyTaking } from '@/models/survey';
import type { SurveyTakingFormValues } from '../../[surveyId]/_components/SurveyTaking';
import { CompleteSurvey } from './CompleteSurvey';
import { SurveyProgress } from './SurveyProgress';
import { SurveyTimer } from './SurveyTimer';
type SurveyTakingInfoProps = {
  currentPage: number;
  totalPage: number;
  currentSurvey?: SurveyTaking;
  onPageChange: (next: boolean) => void;
  formik?: FormikProps<SurveyTakingFormValues>;
  handleSubmitAnswers?: (values: SurveyTakingFormValues) => void;
  entry?: Entry;
  isPreview?: boolean;
  isSubmitting: boolean;
  stopTimer: boolean;
};
export const SurveyTakingInfo = t0 => {
  const $ = _c(30);
  const {
    currentPage,
    totalPage,
    currentSurvey,
    onPageChange,
    formik,
    handleSubmitAnswers,
    entry,
    isPreview,
    isSubmitting,
    stopTimer
  } = t0;
  const displayTimer = currentSurvey && currentSurvey.type.slug === "graded" && currentSurvey.timer && currentPage <= totalPage;
  const t1 = currentSurvey?.type.slug ?? "free";
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      container: "size-6",
      icon: "size-4.5"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== t1) {
    t3 = <SurveyTypeIcon kind={t1} className={t2} />;
    $[1] = t1;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = currentSurvey?.title;
  let t5;
  if ($[3] !== t4) {
    t5 = <h1 className="truncate font-extrabold">{t4}</h1>;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== currentPage || $[6] !== totalPage) {
    t6 = currentPage <= totalPage && totalPage > 1 && <SurveyProgress currentPage={currentPage} totalPage={totalPage} />;
    $[5] = currentPage;
    $[6] = totalPage;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== currentPage || $[9] !== currentSurvey || $[10] !== displayTimer || $[11] !== entry || $[12] !== formik || $[13] !== handleSubmitAnswers || $[14] !== isPreview || $[15] !== stopTimer) {
    t7 = displayTimer && <SurveyTimer currentSurvey={currentSurvey} currentPage={currentPage} formik={formik} handleSubmitAnswers={handleSubmitAnswers} entry={entry} isPreview={isPreview} stopTimer={stopTimer} />;
    $[8] = currentPage;
    $[9] = currentSurvey;
    $[10] = displayTimer;
    $[11] = entry;
    $[12] = formik;
    $[13] = handleSubmitAnswers;
    $[14] = isPreview;
    $[15] = stopTimer;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== currentPage || $[18] !== isSubmitting || $[19] !== onPageChange || $[20] !== totalPage) {
    t8 = <CompleteSurvey currentPage={currentPage} totalPage={totalPage} onPageChange={onPageChange} isSubmitting={isSubmitting} />;
    $[17] = currentPage;
    $[18] = isSubmitting;
    $[19] = onPageChange;
    $[20] = totalPage;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t6 || $[23] !== t7 || $[24] !== t8) {
    t9 = <div className="flex items-center gap-4">{t6}{t7}{t8}</div>;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t3 || $[27] !== t5 || $[28] !== t9) {
    t10 = <div className="dark:bg-background grid h-[54px] grid-cols-[auto_1fr_auto] items-center justify-between gap-4 rounded-lg bg-white px-4">{t3}{t5}{t9}</div>;
    $[26] = t3;
    $[27] = t5;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  return t10;
};